export const MINIMUM_AUTOHIDE_DURATION = 4000
export const MAXIMUM_AUTOHIDE_DURATION = 10000
export const DEFAULT_AUTOHIDE_DURATION = 4000
